import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
  getContract(param) {
    return request({
      url: url + '/contract/page',
      method: 'post',
      data: param,
    })
  },
  getContractExcel(param) {
    return request({
      url: url + '/contract/pageList',
      method: 'post',
      data: param,
    })
  },

  add(data) {
    return request({
      url: url + '/contract/add',
      method: 'post',
      data: data
    })
  },

  edit(data) {
    return request({
      url: url + '/contract/update',
      method: "put",
      data: data
    })
  },

  getById(id) {
    return request({
      url: url + '/contract/getCustomerContractById',
      method: 'get',
      params: {
        id: id
      },
    })
  },

  /*  getById(id) {
      return request({
        url: url + '/contract/getCustomerById',
        method: 'get',
        params: {
          id: id
        },
      })
    }, */

  del(id) {
    return request({
      url: url + '/contract/delete',
      method: 'delete',
      data: id
    })
  },

  uploadFile(formdata) {
    return request({
      url: url + '/contract/receive/file',
      method: 'post',
      data: formdata
    })
  },

  //客户接口

  getByName(name) {
    return request({
      url: url + '/customer/getCustomerByName',
      method: 'get',
      params: {
        customerName: name
      },
    })
  },


  getInspectionContent() {
    return request({
      url: url + '/getInspectionContent',
      method: 'get',
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/contract/contract.js